"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)((_a) => {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)("span", Object.assign({}, props, { children: "Beta" }));
}) `
  display: flex;
  align-items: center;
  height: 24px;
  padding: 0px 8px;
  border-radius: 6px;
  font-size: 14px;
  color: white;
  background: rgba(0, 0, 0, 0.8);
`;
